/**
 * Loads the Razorpay checkout script if not already loaded.
 * Returns a promise that resolves with the global Razorpay constructor.
 */
export const loadRazorpay = () =>
    new Promise((resolve, reject) => {
        if (window.Razorpay) return resolve(window.Razorpay);
        const s = document.createElement("script");
        s.src = "https://checkout.razorpay.com/v1/checkout.js";
        s.async = true;
        s.onload = () => resolve(window.Razorpay);
        s.onerror = () => reject(new Error("Failed to load Razorpay"));
        document.body.appendChild(s);
    });

export const openRazorpay = async ({
    keyId,
    orderId,
    amountPaise,
    name = "Cherishables",
    description = "",
    prefill = {},
    onSuccess,
    onDismiss,
}) => {
    const Razorpay = await loadRazorpay();
    const options = {
        key: keyId,
        amount: amountPaise,
        currency: "INR",
        name,
        description,
        order_id: orderId,
        prefill,
        theme: { color: "#8B2942" },
        handler: (response) => onSuccess?.(response),
        modal: { ondismiss: () => onDismiss?.() },
    };
    const rzp = new Razorpay(options);
    rzp.on("payment.failed", (r) => {
        console.error("payment failed", r);
    });
    rzp.open();
};
